import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import config from '../../../baseConfig';
import { trans } from '../../../helpers';
import ErrorModal from "../../Fragments/ErrorModal";

class B2bUserInfo extends Component {

    constructor( props ){
        super( props );

        this.state = {
            accountListToggle: false,
            showErrorModal: false
        };

        this.componentIsMounted = true;

    }

    componentDidMount() {

        // Hide account
        document.addEventListener('click', ( event ) => {
            if ( this.componentIsMounted && !/^main-wrapper__account/.test( event.target.className ) ) {
                this.setState({ accountListToggle: false })
            }
        }, false);

    }

    componentWillUnmount() {

        this.componentIsMounted = false;

    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.b2bTrans, 'b2b.error.modal.title' )}
                description={trans( this.props.b2bTrans, 'b2b.error.modal.description' )}
                action_text={trans( this.props.b2bTrans, 'b2b.error.modal.action_text' )}
            />
        );

    }

    accountList(){

        if ( !this.state.accountListToggle ) {
            return '';
        }

        return (
            <ul className="main-wrapper__account-list pa">
                <li className="main-wrapper__account-item">
                    <Link
                        className="main-wrapper__account-link main-wrapper__account-link--account db sprite-b pr"
                        to={config.urlPrefix + this.props.urlPrefix + '/myAccount'}
                        onClick={() => {
                            this.setState({ accountListToggle: false }, this.props.updatePath);

                            if ( this.props.curator !== 'curator' ) {
                                this.props.updateParentState({ activeTab: 'inn' });
                            }
                        }}
                    >{trans(this.props.b2bTrans, 'b2b.account_my.title')}</Link>
                </li>
                <li className="main-wrapper__account-item">
                    <Link
                        className="main-wrapper__account-link main-wrapper__account-link--curator db sprite-b pr"
                        to={config.urlPrefix + this.props.urlPrefix + '/curatorList'}
                        onClick={() => {
                            this.setState({ accountListToggle: false }, this.props.updatePath);

                            if ( this.props.curator !== 'curator' ) {
                                this.props.updateParentState({ activeTab: 'inn' });
                            }
                        }}
                    >{trans(this.props.b2bTrans, 'b2b.account_curator.title')}</Link>
                </li>
                <li className="main-wrapper__account-item">
                    <button
                        className={`main-wrapper__account-link main-wrapper__account-link--logout db sprite-b pr full-width tl${this.props.logoutBtnDisabled ? ' btn--loading' : ''}`}
                        disabled={this.props.logoutBtnDisabled}
                        onClick={() => this.props.logout()}
                    >{trans(this.props.b2bTrans, 'b2b.account_logout.title')}</button>
                </li>
            </ul>
        );

    }

    userInfo(){

        let fullName = '...',
            email = '...';

        if ( this.props.profileData !== '' || this.props.profileData.status === 'OK' ) {
            fullName = this.props.profileData.data.first_name + ' ' + this.props.profileData.data.last_name;
            email = this.props.profileData.data.email;
        }

        return (
            <div
                className={`main-wrapper__account-info table sprite-a sprite-b pr trans-background select-none${this.state.accountListToggle ? ' main-wrapper__account-info--active' : ''}`}
                onClick={() => this.setState({ accountListToggle: !this.state.accountListToggle })}
            >
                <div className="main-wrapper__account-info-inner table-cell">
                    <h2 className="main-wrapper__account-fullname monserrat-medium">{fullName}</h2>
                    <p className="main-wrapper__account-email fs14">{email}</p>
                </div>
            </div>
        );

    }

    render() {

        return (
            <div className="main-wrapper__account fr pr">
                {this.userInfo()}
                {this.accountList()}
                {this.errorModal()}
            </div>
        );

    }

}

export default B2bUserInfo;